import React from 'react'
import '../styles/basicLayout.css'
import '../styles/editRecipe.css'

export default function EditRecipe({ visible, handleClose, recipe, handleDeleteRecipe, handleEditRecipe }) {
  return (
    <div id="popup1" className="overlay" style={{ visibility: visible ? 'visible' : 'hidden' }}>
      <div className="popup">
        <div className="top">
          <a className='close' onClick={handleClose}>&times;</a>
        </div>
    
        <h2>What would you like to do to {recipe?.name} ?</h2>

        <div className="content">
          <button className="button" onClick={() => handleEditRecipe(recipe?._id)}>Edit</button>
          <button className="button" onClick={() => handleDeleteRecipe(recipe?._id)}>Delete</button>
        </div>
      </div>
    </div>
  )
}